/*
 * Public API Surface of tax
 */

export * from './Taxwc-angular';
export * from './Taxwd-angular';
export * from './_edit_tax';
export * from './_entity_tax';
export * from './_service_tax';
export * from './_tax';
export * from './tax.module';
export * from './taxwc.service';
export * from './taxwcPkg.service';
export * from './taxwd.service';
export * from './taxwdPkg.service';

export * from './taxpq80/taxpq80.component';
export * from './taxpi92/taxpi92BillPkg.component';

